import posthog from 'posthog-js'
import { takeLatest, select } from 'redux-saga/effects'
import { FETCH_USER_DATA_SUCCESS } from 'dealer-reducers'
import { RootReducer } from 'src/redux/rootReducer'
import { getDeviceId } from 'src/helpers/deviceId'
import { isPosthogReady } from 'src/helpers/posthog'

function* IdentifyUserFlow(): Generator<unknown, void, RootReducer['userDataReducer']> {
  const userData: RootReducer['userDataReducer'] = yield select((state: RootReducer) => state.userDataReducer)
  if (userData.email !== '') {
    localStorage.setItem('dealer_email', userData.email)
    getDeviceId()
  }
  if (isPosthogReady() && userData.id !== 0) {
    posthog.identify(userData.id.toString(), {
      email: userData.email,
      company_name: userData.company_name
    })
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function* IdentifyUserSaga(): Generator<any, void, any> {
  yield takeLatest(FETCH_USER_DATA_SUCCESS, IdentifyUserFlow)
}
